// components
import BottomNavigation from "../kits/bottomNavigation/BottomNavigation.jsx";

// react & hooks
import useWindowSize from "../../hooks/useWindowSize.jsx";

export default function Layout(props) {
  const { width, height } = useWindowSize();

  return (
    <div className="bg-layout">
      <div className="layout-container mr-x-auto" id="root-container">
        <div id="drawer-container" />

        <div
          className={`scroll `}
          style={{ height: props.bottomNav ? `${height - 73}px` : "100vh" }}
        >
          {props.children}
        </div>
        {props.bottomNav && <BottomNavigation />}
      </div>
    </div>
  );
}
